import { format } from '../models/format'
import { validateAge, validateNaturalGovernmentId } from './governmentIdUtils'
import { Countries } from '../models/countries'

const OrganisationTypes = {
  ENSKILD_FIRMA: 'ENSKILD_FIRMA',
  STAT: 'STAT',
  AKTIE_BOLAG: 'AKTIE_BOLAG',
  ENKELT_BOLAG: 'ENKELT_BOLAG',
  EKONOMISK_FORENING: 'EKONOMISK_FORENING',
  IDEEL_FORENING: 'IDEEL_FORENING',
  HANDELS_KOMMANDIT_BOLAG: 'HANDELS_KOMMANDIT_BOLAG',
  NOT_SUPPORTED: 'NOT_SUPPORTED',
}

const isEnskildFirma = (countryCode, organisationId) => {
  return (
    new RegExp(format.governmentId.SE.regex).test(organisationId) &&
    validateAge(countryCode, organisationId) &&
    validateNaturalGovernmentId(countryCode, organisationId)
  )
}

const isNonOrganisationId = organisationId =>
  organisationId && organisationId.toString().substring(2, 4) < 20

const getOrganisationType = internalOrganisationId => {
  if (internalOrganisationId && isNonOrganisationId(internalOrganisationId)) {
    return OrganisationTypes.ENSKILD_FIRMA
  }

  const typeIdent = internalOrganisationId.toString().substring(0, 1)

  switch (typeIdent) {
    case '2':
      return OrganisationTypes.STAT
    case '5':
      return OrganisationTypes.AKTIE_BOLAG
    case '6':
      return OrganisationTypes.ENKELT_BOLAG
    case '7':
      return OrganisationTypes.EKONOMISK_FORENING
    case '8':
      return OrganisationTypes.IDEEL_FORENING
    case '9':
      return OrganisationTypes.HANDELS_KOMMANDIT_BOLAG
    default:
      return OrganisationTypes.NOT_SUPPORTED
  }
}

const convertOrganisationIdToInternalForm = organisationId => {
  const isValidOrganisationExpression = new RegExp(format.orgNr.SE.regex).test(
    organisationId,
  )
  const organisationIdLength = organisationId.toString().length
  if (isValidOrganisationExpression && organisationIdLength === 10) {
    return organisationId
  }
  if (isValidOrganisationExpression && organisationIdLength === 11) {
    return organisationId.toString().replace('-', '')
  }
  if (isValidOrganisationExpression && organisationIdLength === 12) {
    return organisationId.toString().substring(2, 12)
  }
  return ''
}

const validateOrganisationId = (organisationId, organisationType) => {
  switch (organisationType) {
    case OrganisationTypes.ENSKILD_FIRMA:
      return isEnskildFirma(Countries.SE, organisationId)
    case OrganisationTypes.STAT:
    case OrganisationTypes.AKTIE_BOLAG:
    case OrganisationTypes.ENKELT_BOLAG:
    case OrganisationTypes.EKONOMISK_FORENING:
    case OrganisationTypes.IDEEL_FORENING:
    case OrganisationTypes.HANDELS_KOMMANDIT_BOLAG:
      return new RegExp(format.orgNr.SE.regex).test(organisationId)
    default:
      return false
  }
}

export const validateSwedishLegalGovernmentId = organisationId => {
  const internalFormOfOrganisationId =
    convertOrganisationIdToInternalForm(organisationId)
  const organisationType = getOrganisationType(internalFormOfOrganisationId)
  return validateOrganisationId(organisationId, organisationType)
}
